export type SponsorType = {
  preview: Array<string> | undefined
  name: string
  description: string
  linkText: string
  emailURL: string
  webURL: string
  darkLogoURL: string
  lightLogoURL: string
  eventSlugScope?: Array<string>
  marginTop?: number
}

export const SPONSORS: Array<SponsorType> = [
  {
    preview: undefined,
    name: 'Clerk',
    description:
      'Clerk simplifies the process of adding authentication & user management to get you up and running in minutes. Our product is purpose-built for Next.js, React and the modern web.',
    linkText: 'https://clerk.com',
    emailURL:
      'https://clerk.com/?utm_source=sponsorship&utm_medium=event&utm_campaign=guild.host&utm_content=email',
    webURL:
      'https://clerk.com/?utm_source=sponsorship&utm_medium=event&utm_campaign=guild.host&utm_content=website',
    darkLogoURL:
      'https://ik.imagekit.io/guild/sponsors/clerk/tr:w-150,dpr-3/clerk-logo-dark-mode_4Yr7DYEql.png?updatedAt=1705667573915',
    lightLogoURL:
      'https://ik.imagekit.io/guild/sponsors/clerk/tr:w-150,dpr-3/clerk-logo-dark-ascent_FjeXsoPw6.png?updatedAt=1705669959479',
  },
  {
    preview: undefined,
    name: 'Liveblocks',
    description:
      'Liveblocks is real-time infrastructure to create collaborative experiences like Figma & Notion in a matter of days, not months. Our toolkit is purpose-built for the JS, React, and Next.js ecosystem.',
    linkText: 'https://liveblocks.io',
    emailURL: 'https://liveblocks.io',
    webURL: 'https://liveblocks.io',
    darkLogoURL:
      'https://ik.imagekit.io/guild/sponsors/liveblocks/tr:w-150,dpr-3/liveblocks-logo-light_crQF655AB.png?updatedAt=1705745859168',
    lightLogoURL:
      'https://ik.imagekit.io/guild/sponsors/liveblocks/tr:w-150,dpr-3/liveblocks-logo-dark_yWYiZGbVI.png?updatedAt=1706688892076',
  },
  // {
  //   preview: undefined,
  //   name: 'Agemo',
  //   description:
  //     "Agemo is hiring! We're building an AI-native platform for technical audiences to create and deploy complex software in minutes or hours using natural language, enabling non-coders to build tools and developers to ship faster. Like a ChatGPT for software.",
  //   linkText: 'https://agemo.ai/careers',
  //   emailURL: 'https://agemo.ai/careers',
  //   webURL: 'https://agemo.ai/careers',
  //   darkLogoURL:
  //     'https://ik.imagekit.io/guild/sponsors/agemo/tr:w-150,dpr-3/Agemo-Logo-Transparent%20white_Fi1LfRaZo.png?updatedAt=1707844139824',

  //   lightLogoURL:
  //     'https://ik.imagekit.io/guild/sponsors/agemo/tr:w-150,dpr-3/Agemo-Logo-Transparent_fh16SUe1-.png?updatedAt=1707844148773',

  //   eventSlugScope: ['zstd38', '000005'],
  //   marginTop: 8,
  // },
  {
    preview: undefined,
    name: 'Sentry',
    description: `Don't let broken lines of code, busted API calls, and crashes ruin you app. Join the 4M developers and 90K organizations who consider Sentry “not bad” when it comes to application monitoring. Use code “guild” for 3 free months of the team plan.`,
    linkText: 'https://sentry.io',
    emailURL:
      'https://sentry.io/welcome/?utm_source=guild&utm_medium=paid-community&utm_campaign=general-fy25q1-evergreen&utm_content=logo-guildboilerplate-getsentry&code=guild',
    webURL:
      'https://sentry.io/welcome/?utm_source=guild&utm_medium=paid-community&utm_campaign=general-fy25q1-evergreen&utm_content=logo-guildboilerplate-getsentry&code=guild',
    darkLogoURL:
      'https://ik.imagekit.io/guild/sponsors/sentry/tr:w-150,dpr-3/sentry-wordmark-light-400x119%20(1)_mGGlmpJ-5.png?updatedAt=1708512769728',
    lightLogoURL:
      'https://ik.imagekit.io/guild/sponsors/sentry/tr:w-150,dpr-3/sentry-wordmark-dark-400x119_YebqsxfIV.png?updatedAt=1708512778585',
  },
]
